<template>
    <div class="navbar-collapse collapse">
        <ul class="navbar-nav ms-auto">
            
            <li class="nav-item dropdown ms-lg-2">
                <div class="nav-link dropdown-toggle position-relative"
                    ref="sideBtn" 
                    @click="toggleNavBar"
                >
                    <i class="align-middle fas fa-cog"></i>
                </div>
                <div class="dropdown-menu "
                    :class="{ show: isNavBarVisible }"
                    ref="sideMenu"
                >
                    <router-link 
                        v-if="checkPermission('users')"
                        to="/account"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-users"></i> <span>帳號管理</span>
                    </router-link>

                    <router-link 
                        v-if="checkPermission('role')"
                        to="/role"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-user-shield"></i> <span>角色管理</span>
                    </router-link>

                    <router-link 
                        v-if="checkPermission('species')"
                        to="/species"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-paw"></i> <span>物種管理</span>
                    </router-link>

                    <router-link 
                        v-if="checkPermission('parameters')"
                        to="/parameter"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-cogs"></i> <span>參數管理</span>
                    </router-link>

                    <router-link 
                        v-if="checkPermission('ft') && ( checkSubPermission('ft','create-form') || checkSubPermission('ft','update-form') )"
                        to="/releaseForms"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-clipboard-list"></i> <span>野放訓練評估表單管理</span>
                    </router-link>

                    <router-link 
                        v-if="checkPermission('typeSurvey')"
                        to="/typeForms"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-file-signature"></i> <span>型質測量表單管理</span>
                    </router-link>

                    <router-link 
                        v-if="checkPermission('schedule')"
                        to="/schedule"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-calendar-alt"></i> <span>班表管理</span>
                    </router-link>

                    <router-link 
                        v-if="checkPermission('vendor')"
                        to="/vendor"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-store-alt"></i> <span>廠商管理</span>
                    </router-link>

                    <router-link class="dropdown-item" to="/resetPassword">
                        <i class="align-middle me-1 fas fa-fw fa-user-lock"></i> <span>變更密碼</span>
                    </router-link>

                    <!-- 外部連結暫時存放 -->
                    <div class="dropdown-item"
                        @click="openOutSideCreateIntake"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-clipboard"></i> <span>開啟外部受理單連結</span>
                    </div>
                    <!-- <router-link to="/createIntake"
                        class="dropdown-item">
                        <i class="align-middle me-1 fas fa-fw fa-clipboard"></i> <span>外部受理單(暫放)</span>
                    </router-link> -->
                    <!-- 開發測試用 -->
                    <div class="dropdown-divider"></div>
                    <router-link to="/dev/setting"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-drafting-compass"></i> <span>開發測試設定用</span>
                    </router-link>

                    <a href="https://drive.google.com/file/d/1EVkG3bmrhc95OGxs2mYozSiEzYVXp0WP/view?usp=sharing" target="_blank" rel="noopener noreferrer"
                        class="dropdown-item"
                    >
                        <i class="align-middle me-1 fas fa-fw fa-info"></i> <span>教學手冊</span>
                    </a>
                    
                    <div class="dropdown-divider"></div>
                    <router-link class="dropdown-item" to="/login">
                        <i class="align-middle me-1 fas fa-fw fa-arrow-alt-circle-right"></i> <span>登出</span>
                    </router-link>
                </div>
            </li>
        </ul>
        <openOutSideCreateIntake ref="openOutSideCreateIntake"
        ></openOutSideCreateIntake>
    </div>
</template>
  
<script>
import openOutSideCreateIntake from '@/components/openOutSideCreateIntake.vue'
export default {
    name:'sideMenuView',
    components:{openOutSideCreateIntake},
    data() {
        return {
            userPermission:null,
            isNavBarVisible: false,
        };
    },
    watch: {
        $route(to, from) {
            this.isDropdownOpen = false;
            this.isNavBarVisible = false
        },
        isDropdownOpen(value) {
            if (value) {
                document.addEventListener('click', this.handleSideClickOutside);
            } else {
                document.removeEventListener('click', this.handleSideClickOutside);
            }
        }
    },
    methods:{
        toggleNavBar() {
            this.isNavBarVisible = !this.isNavBarVisible;
        },
        hideNavBar() {
            this.isNavBarVisible = false;
        },
        handleSideClickOutside(event) {
            const sideMenu = this.$refs.sideMenu;
            const sideBtn = this.$refs.sideBtn;
            // 如果點擊的區域不是 navBar 或 mainBtn，則隱藏 nav-bar
            if (!sideMenu.contains(event.target) && !sideBtn.contains(event.target)) {
                this.hideNavBar();
            }
        },
        checkPermission(key){
            const permission = this.userPermission != null ? this.userPermission.find(item=>item.key===key) : null
            return permission ? permission.status : false
        },
        checkSubPermission(key,subKey){
            const permission = this.userPermission != null ? this.userPermission.find(item=>item.key===key) : null
            if ( ( permission ? permission.status : false ) ){
                const subPermission = permission.sub.find(item=>item.key===subKey)
                return subPermission ? subPermission.status : false
            }
            return false
        },
        openOutSideCreateIntake(){
            this.$refs.openOutSideCreateIntake.show()
        }
    },
    created(){
        const userPermission = this.$api.users.getUserPermission()
        console.log("userPermission=",userPermission)
        if ( userPermission == null ){
            this.$router.push('/login')
            return
        }
        this.userPermission = userPermission.role_permission_json

        // 點擊畫面其他區域時關閉 nav-bar
        document.addEventListener('click', this.handleSideClickOutside);
    },
    beforeUnmount() {
        // 移除事件監聽
        document.removeEventListener('click', this.handleSideClickOutside);
    },
};
</script>
<style scoped>
.dropdown-item {
    display: flex;
    align-items: baseline;
}
.dropdown-item:hover {
    background-color: #d8d8d8;
}
.dropdown .dropdown-menu.show {
    position: fixed;
    position: absolute;
    right: 0px;
}
</style>